// extracted by mini-css-extract-plugin
module.exports = {"fullPageLoaderContainer":"fullPageLoader_fullPageLoaderContainer___GYOR"};